import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { useChatStore } from './chatStore';

interface User {
  id: string;
  email: string;
  name?: string;
  role?: string;
  timezone?: string;
  language?: string;
  tracks?: string[];
  onboarding_complete?: boolean;
  [key: string]: any;
}

interface AuthState {
  user: User | null;
  session: any | null;
  loading: boolean;
  setUser: (user: User | null) => void;
  setSession: (session: any) => void;
  setLoading: (loading: boolean) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      session: null,
      loading: true,
      setUser: (user) => set({ user }),
      setSession: (session) => set({ session }),
      setLoading: (loading) => set({ loading }),
      logout: () => {
        localStorage.removeItem('axis_onboarded');
        localStorage.removeItem('axis_user_name');
        // Reset cached AXIS chat (both in-memory state AND persisted storage)
        // so the next user on this device never sees the previous account's
        // messages — even on a fast user switch within the same SPA session.
        try { useChatStore.getState().clearChat(); } catch (e) { console.warn('[logout] clearChat failed', e); }
        localStorage.removeItem('axis-chat');
        set({ user: null, session: null, loading: false });
      },
    }),
    {
      name: 'axis-auth',
      partialize: (state) => ({
        user: state.user,
        session: state.session,
      }),
    }
  )
);
